import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ideatrip() {
  return (
    <section className="idea_trip text_trip">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={4}
            xl={4}
            xxl={4}
            className="my-auto text-center resp_order"
          >
            <div className="idea_trip_img">
              <StaticImage
                src="../../../images/case-studies/equi-trip/idea_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={392}
                height={650}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-2 offset-lg-2"
          >
            <h1>
              The Idea Behind <span>Equitrip</span>
            </h1>
            <p>
              Our esteemed client, H.E Prince Al-Mansour, is an equine lover and
              an active athlete, participating in competitions around the globe.
              He came across the problem that equine owners face while needing
              to transport their horses for global competitions. It wasn’t easy
              to find the right transportation company on time.
            </p>
            <p>
              Understanding the pain points, he then thought of this great
              solution where equine owners, transportation companies, and other
              key stakeholders would be provided a platform to connect and make
              transportation plans easier.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ideatrip;
